import React, { Component } from 'react';


class DakshHeader extends Component {
    render() {
        return (
            <div className="row">
                <div className="col-12">
                    <div className="text-center">
                        <h3 className="title">
                            <i className="customic ic-daksh mr-3"></i>
                            Daksh
                        </h3>
                    </div>
                </div>
            </div>
        )
    }
}

export default DakshHeader;
